import { CartMessages } from '@zooplus/checkout-state';
import { Language } from '@zooplus/commons-lang';

export const hasMessageWithCode = (messages: CartMessages[] | undefined, code: string) =>
  messages?.some((message) => message.code === code);

export const setDocumentLang = (lang: Language) => {
  document.documentElement.lang = lang;
};
